/* NOVALISE — convert PDP info h6/p sections into real collapsible <details>.
 * Horizon text block sanitizes <details>, so we build accordions at runtime.
 * Styling handled by nv-pdp-cart.css [data-template="product"] details. */
(function () {
  var HEADINGS = ['composición y cuidados', 'envíos y entregas', 'devoluciones y cambios', 'guía de tallas', 'composicion y cuidados', 'envios y entregas', 'guia de tallas'];
  function norm(s) { return (s || '').trim().toLowerCase(); }

  function build() {
    var root = document.querySelector('[data-template="product"]');
    if (!root) return;
    var h6s = Array.prototype.slice.call(root.querySelectorAll('h6'));
    h6s.forEach(function (h6) {
      if (h6.dataset.nvAcc) return;
      if (HEADINGS.indexOf(norm(h6.textContent)) === -1) return;
      // collect following siblings until next info h6
      var body = [];
      var n = h6.nextElementSibling;
      while (n && !(n.tagName === 'H6' && HEADINGS.indexOf(norm(n.textContent)) !== -1)) {
        var next = n.nextElementSibling;
        body.push(n);
        n = next;
      }
      if (!body.length) return;
      var details = document.createElement('details');
      details.className = 'nv-acc';
      var summary = document.createElement('summary');
      summary.textContent = h6.textContent;
      details.appendChild(summary);
      body.forEach(function (el) { details.appendChild(el); });
      h6.dataset.nvAcc = '1';
      h6.parentNode.insertBefore(details, h6);
      h6.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  setTimeout(build, 800);
  setTimeout(build, 2000);
})();
